import type { ReactElement } from "react";

import { useTranslate } from "@similarweb/i18n-provider";

import type { IFilterViewBaseProps } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filterInstance";
import type { IRange } from "app/pages/sales-intelligence/types/range";
import { is } from "app/pages/sales-intelligence/utils/type-guards";

import type FindAdSpendChannelsFilter from "../../../models/AdSpendChannelsFilter/AdSpendChannelsFilter";
import type { IAdSpendChannelsFilterDto } from "../../../types/leadsSearchFilters.dto";
import leadsSearchFiltersI18nKeys from "../../../utils/i18n";
import RangeSlider from "../../RangeSlider/RangeSlider";
import { FilterContentContainer } from "../styles";

import { CHANNELS_KEYS } from "./const";

const AdSpendChannelsFilter = ({
    filter: {
        options: { channelShare },
    },
    value,
    onFilterUpdate,
}: IFilterViewBaseProps<FindAdSpendChannelsFilter>): ReactElement | null => {
    const { translate } = useTranslate();

    const handleAfterChange = (key: keyof IAdSpendChannelsFilterDto, range: Partial<IRange<number>>) => {
        const updated = { ...value };

        if (is.undefined(range.from) && is.undefined(range.to)) {
            delete updated[key];
        } else {
            updated[key] = range;
        }

        onFilterUpdate(updated);
    };

    return (
        <FilterContentContainer>
            {CHANNELS_KEYS.map((key) => (
                <RangeSlider
                    key={key}
                    name={key}
                    title={translate(leadsSearchFiltersI18nKeys.filter(key))}
                    options={channelShare}
                    value={value?.[key]}
                    onAfterChange={(val: Partial<IRange<number>>) => handleAfterChange(key, val)}
                />
            ))}
        </FilterContentContainer>
    );
};

export default AdSpendChannelsFilter;
